const GENERIC = /^(?:watch(?: live)?|live|stream(?:ing)?|video|live video|broadcast|tv|audio|listen|coverage|none|tba|n\/a)$/i;
const KEY = /^(?:name|label|title|displayname|shortname|network(?:s|name)?|broadcaster(?:s|name)?|provider(?:s|name)?|service(?:s|name)?|platform|channel(?:s|name)?|tv|television|telecast|broadcasts?|media(?:coverage)?|videos?|streams?|streaming(?:provider)?|livevideos?|webcasts?|watch(?:info|links)?|coverage)$/;
function clean(value) {
  if (typeof value !== 'string') return '';
  const text = value.replace(/<[^>]*>/g, '').replace(/&amp;/g, '&').replace(/\s+/g, ' ').trim();
  if (!text || /(?:https?:\/\/|www\.|^\/)/i.test(text) || GENERIC.test(text) || /^\d+$/.test(text)) return '';
  const aliases = { 'espn plus':'ESPN+', 'espn+':'ESPN+', 'acc network extra':'ACCNX', 'accnx':'ACCNX', 'sec network plus':'SECN+', 'sec network+':'SECN+', 'secn+':'SECN+', 'youtube':'YouTube', 'fox sports 1':'FS1', 'fs1':'FS1', 'mountain west network':'MW+', 'mw+':'MW+', 'midco sports plus':'Midco Sports Plus' };
  return aliases[text.toLowerCase()] || text;
}
function collect(value, names, depth = 0, seen = new WeakSet()) {
  if (value == null || depth > 8) return;
  if (typeof value === 'string') {
    value.split(/\s+[·|]\s+|\s*;\s*/).forEach((part) => { const label = clean(part); if (label) names.add(label); });
    return;
  }
  if (typeof value !== 'object' || seen.has(value)) return;
  seen.add(value);
  if (Array.isArray(value)) { value.forEach((item) => collect(item, names, depth + 1, seen)); return; }
  Object.entries(value).forEach(([key, item]) => {
    if (KEY.test(key.toLowerCase().replace(/[^a-z]/g, ''))) collect(item, names, depth + 1, seen);
  });
}
export function normalizeBroadcastNames(...values) {
  const names = new Set();
  values.forEach((value) => collect(value, names));
  return [...names].filter((name, index, list) => list.findIndex((item) => item.toLowerCase() === name.toLowerCase()) === index);
}
export function broadcastLabel(...values) { return normalizeBroadcastNames(...values).join(' · '); }

export function gameBroadcastLabel(game, depth = 0) {
  if (!game || typeof game !== 'object' || depth > 5) return '';
  if (Array.isArray(game)) return broadcastLabel(...game.map((item) => gameBroadcastLabel(item, depth + 1)));
  const providers = [];
  Object.entries(game).forEach(([key, value]) => {
    const field = key.toLowerCase().replace(/[^a-z]/g, '');
    if (/^(?:network(?:s|name)?|broadcaster(?:s|name)?|television|tv|broadcasts?|media(?:coverage)?|videos?|livevideos?|streams?|streaming(?:provider)?|webcasts?|watch(?:info|links)?|coverage)$/.test(field)) providers.push(value);
    else if (/^(?:game|games|contest|contests|data|event|events|gamecentergame|payload)$/.test(field)) providers.push(gameBroadcastLabel(value, depth + 1));
  });
  return broadcastLabel(...providers);
}
